import "../../assets/style/main.css";
import "./style.scss"
import { useEffect, useRef, useState } from "react";
import $ from 'jquery'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
const MySwal = withReactContent(Swal)
import PageLoader from "../../components/PageLoader";
import { isPageLoading } from "../../components/PageLoader";
import ARROW_DOWN_ICON from '../../assets/images/icons/arrow-b.png'
import CLOSE_ICON from '../../assets/images/icons/close-btn-2.png'
import { EncryptedOBJ, DecryptedOBJ, EncryptedText, DecryptedText } from "../../utils/Encryption";
import moment from "moment";
import SignIn_Navbar from "../../components/SignIn_Navbar";
import { Base_API } from "../../_actions/matcher";
import { getMemberLab, getMemberNonLab, isMembership } from "../../_actions/lineoa.authen";
import { getHeadersAuthenLineId } from "../../_actions/sso.authen";
import { NhealthAction } from "../../_actions/action.api";
import ContentLoader, { isContentLoading } from "../../components/ContentLoader";
import { ALERT } from "../../components/CustomAlert";


export default function SignUp_FormInfo() {
    let onceMount = useRef(true);
    const DOB_DAY = useRef(null);
    const DOB_MONTH = useRef(null);
    const DOB_YEAR = useRef(null);
    const INPUT_CARD_ID = useRef(null);
    const INPUT_PASSPORT_ID = useRef(null);
    const INPUT_FULLNAME_TH = useRef(null);
    const INPUT_FULLNAME_EN = useRef(null);
    const DD_GENDER = useRef(null);
    const INPUT_AGE = useRef(null);
    const INPUT_PHONE_NUMBER = useRef(null); 
    const INPUT_EMAIL = useRef(null);
    const INPUT_FIRSTNAME_TH = useRef(null);
    const INPUT_LASTNAME_TH = useRef(null);
    const INPUT_FIRSTNAME_EN = useRef(null);
    const INPUT_LASTNAME_EN = useRef(null);

    useEffect(() => {
        if (onceMount.current) {
            pageInit();
            onceMount.current = false;
        }
    }, []);

    const [typeRegis, setTypeRegis] = useState(true); // true = idcard | false = passport
    const [ddMonth, setDDmonth] = useState([
        {
            id: 1,
            nameTH: "มกราคม",
            nameEN: "Jan",
        },
        {
            id: 2,
            nameTH: "กุมภาพันธ์",
            nameEN: "Feb",
        },
        {
            id: 3,
            nameTH: "มีนาคม",
            nameEN: "Mar",
        },
        {
            id: 4,
            nameTH: "เมษายน",
            nameEN: "Apr",
        },
        {
            id: 5,
            nameTH: "พฤษภาคม",
            nameEN: "May",
        },
        {
            id: 6,
            nameTH: "มิถุนายน",
            nameEN: "Jun",
        },
        {
            id: 7,
            nameTH: "กรกฎาคม",
            nameEN: "Jul",
        },
        {
            id: 8,
            nameTH: "สิงหาคม",
            nameEN: "Aug",
        },
        {
            id: 9,
            nameTH: "กันยายน",
            nameEN: "Sept",
        },
        {
            id: 10,
            nameTH: "ตุลาคม",
            nameEN: "Oct",
        },
        {
            id: 11,
            nameTH: "พฤศจิกายน",
            nameEN: "Nov",
        },
        {
            id: 12,
            nameTH: "ธันวาคม",
            nameEN: "Dec",
        },
    ]);
    const [ddDays, setDDdays] = useState([]);
    const [ddYears, setDDyears] = useState([]);
    const [ddGender, setDDgender] = useState([
        {
            id: 1,
            nameTH: "ชาย",
            nameEN: "male",
        },
        {
            id: 2,
            nameTH: "หญิง",
            nameEN: "female",
        },
        // { id: 3,
        //     nameTH: "อื่นๆ",
        //     nameEN: "other",
        // },
    ]);
    const [formData, setFormData] = useState({
        card_id: "",
        passport: "",
        first_name_th: "",
        last_name_th: "",
        first_name_en: "",
        last_name_en: "",
        dob: "",
        gender: "",
        age: 0,
        phone: "",
        email: "",
        back_idcard: ""
    });
    const [lockInputCardID, setLockInputCardID] = useState(false);
    // const [isOpen, setIsOpen] = useState(false);
    const [errorMsg, setErrorMsg] = useState({
        idcard: "",
        passport: "",
        first_name_th: "",
        last_name_th: "",
        first_name_en: "",
        last_name_en: "",
        gender: "",
        age: "",
        tel: "",
        email: "",
        back_idcard: ""
    });
    const [isCardMember, setIsCardMember] = useState(false);
    const [cardMemberPhoneNo, setCardMemberPhoneNo] = useState(null);
    const [ssoPhoneMsg, setSsoPhoneMsg] = useState("");
    const [isLab, setIsLab] = useState(false);
    const [isNonLab, setIsNonLab] = useState(false);


    const pageInit = async () => {
        await dropdownInit();
        checkCurrentURL();
        await idcardInfoInit();
        // await signinPhone();
        // await signinEmail();

        // let jwtToken = await getJWTToken();
        // await getProfile(jwtToken);
        // await EditProfile(jwtToken);

        // let OTP = await sendOTPSMS();
        // await sendOTPEmail();
        // await verifyOTP(); 

        // await getUserSignin();

        // await registration();

        isPageLoading(false);
    };

    const checkCurrentURL = () => {
        let pathname = location.pathname;
        localStorage.setItem(process.env.REACT_APP_ENCNAME_CURRENTPAGEURL, EncryptedText(pathname));
        localStorage.setItem(process.env.REACT_APP_ENCNAME_CAMEFROM_URL, EncryptedText(pathname));
    }

    const idcardInfoInit = () => {
        return new Promise(async resolve => {
            let dataEncName = process.env.REACT_APP_ENC_NAME_CAPTURE_IDCARD;
            let dataEnc = localStorage.getItem(dataEncName);
            let enc_typeRegis = localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_REGIS);
            let dec_typeRegis = DecryptedText(enc_typeRegis);
            console.log('type register: ', dec_typeRegis);
            console.log('Data Enc: ', dataEnc);
            if(!!dataEnc)
            {
                // Citizent ID (Input Init)
                if(dec_typeRegis === 'idcard')
                {
                    setTypeRegis(true);
                }else
                {
                    setTypeRegis(false);
                }
                // check nhealth card membership
                let membershipLab = await getMemberLab();
                let membershipNonLab = await getMemberNonLab();
                setIsLab(membershipLab);
                setIsNonLab(membershipNonLab);
                let phoneMember = await initPhoneNo(membershipLab, membershipNonLab)

                let dataDecrypted = DecryptedOBJ(dataEnc);
                console.log('Data Dec: ', dataDecrypted);
                let dob = String(dataDecrypted.dob).split('-');
                let day = Number(dob[0])
                let month = Number(dob[1]);
                let year = Number(dob[2])
                let currentAge = calculateAge(String(day), String(month), String(year));
                let formatCardID = formatNationalID(String(dataDecrypted.card_id))
                let firstname_th = String(dataDecrypted.full_name).split(" ")[0];
                let lastname_th = String(dataDecrypted.full_name).split(" ")[1];
                let firstname_en = String(dataDecrypted.full_name_en).split(" ")[0];
                let lastname_en = String(dataDecrypted.full_name_en).split(" ")[1];
    
    
                console.log('Card Info: ', dataDecrypted);
    
                $(DOB_YEAR.current).prop('value', year);
                $(DOB_MONTH.current).prop('value', month);
                $(DOB_DAY.current).prop('value', day);
                if(dec_typeRegis === 'idcard' && (!!firstname_en && !!lastname_en))
                {
                    // INPUT_CARD_ID.current.value = formatCardID;
                    setFormData({...formData, card_id: formatCardID, first_name_en: firstname_en, last_name_en: lastname_en, first_name_th: firstname_th, last_name_th: lastname_th, phone: phoneMember})
                    INPUT_FIRSTNAME_EN.current.value = firstname_en;
                    INPUT_LASTNAME_EN.current.value = lastname_en;
                    INPUT_FIRSTNAME_TH.current.value = firstname_th;
                    INPUT_LASTNAME_TH.current.value = lastname_th;
                }else
                {
                    // INPUT_PASSPORT_ID.current.value = formatCardID;
                    setFormData({...formData, passport: formatCardID, first_name_en: firstname_en, last_name_en: lastname_en, phone: phoneMember})
                    INPUT_FIRSTNAME_EN.current.value = firstname_en;
                    INPUT_LASTNAME_EN.current.value = lastname_en;
                }
                // INPUT_FULLNAME_EN.current.value = dataDecrypted.full_name;
                // INPUT_AGE.current.value = currentAge;
    
                // setLockInputCardID(true);
            }
            resolve();
        })
    }

    function dropdownInit() {
        return new Promise(async resolve => {
            let monthNumber = new Date().getMonth()+1;
            let days = getDaysInMonth(monthNumber);
            let daysList = getDaysList(days);
            let yearList = getYearList();
            let currentAge = calculateAge(daysList[0], 1, yearList[0]);
    
            setDDdays(daysList);
            setDDyears(yearList);
            resolve();
        })
    }

    const initPhoneNo = (membershipLab, membershipNonLab) => {
        return new Promise(async resolve => {
            console.log('membershipLab: ',membershipLab);
            console.log('membershipNonLab: ',membershipNonLab);

            if(!!membershipLab)
            {
                console.log('11111');
                setIsCardMember(true);
                setCardMemberPhoneNo(membershipLab.Phoneno);
                let formatValue = formatThaiPhoneNumber(membershipLab.Phoneno);
                // Set phone number init
                // setFormData({ ...formData, phone: formatValue });
                // Set remark
                setErrorMsg({
                    ...errorMsg, tel: 'ไม่สามารถเปลี่ยนแปลงหมายเลขโทรศัพท์ได้เนื่องจากท่านได้ใช้เบอร์นี้สมัคร N Health Card แล้ว'
                }) 
                resolve(formatValue);
            }else
            {
                if(!!membershipNonLab)
                {
                    console.log('22222');
                    setIsCardMember(true);
                    setCardMemberPhoneNo(membershipNonLab.Phoneno);
                    let formatValue = formatThaiPhoneNumber(membershipNonLab.Phoneno);
                    console.log('membershipNonLab.Phoneno: ', membershipNonLab.Phoneno);
                    console.log("formatValue: " ,formatValue );
                    // Set phone number init
                    let newForm = formData;
                    newForm["phone"] = formatValue;
                    // setFormData(newForm);
                    // Set remark
                    setErrorMsg({
                        ...errorMsg, tel: 'ไม่สามารถเปลี่ยนแปลงหมายเลขโทรศัพท์ได้เนื่องจากท่านได้ใช้เบอร์นี้สมัคร N Health Card แล้ว'
                    }) 
                    resolve(formatValue);
                }else
                {
                    console.log('33333');
                    resolve("");
                }
            }
        })
    }



    function getDaysInMonth(monthId) {
        // Create a new Date object for the specified month
        const date = new Date(2023, monthId, 0);

        // Get the number of days in the month
        const daysInMonth = date.getDate();

        return daysInMonth;
    }
    const getDaysList = (days) => {
        let daysList = new Array();
        for (let i = 1; i <= days; i++) {
            daysList.push(i);

            if (Number(i) === days) {
                return daysList;
            }
        }
    };
    const getYearList = () => {
        let yearList = new Array();
        let year = new Date().getFullYear();
        let minYear = year - 100;

        for (let i = minYear; i <= year; i++) {
            yearList.push(i);

            if (Number(i) === year) {
                yearList = yearList.sort(function (a, b) {
                    return b - a;
                }); // ASC มากไปน้อย
                return yearList;
            }
        }
    };
    function calculateAge(day, month, year) {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1; // Months are zero-based
        const currentDay = currentDate.getDate();

        let age = currentYear - year;

        // Check if the current date (month and day) is before the birthdate
        if (currentMonth < month || (currentMonth === month && currentDay < day)) {
            age--;
        }

        return age < 0 ? 0 : age; // Don't Return Value = 0
    }

    const handleChange = (e) => {
        let name = e.target.name;
        let day = DOB_DAY.current.value;
        let month = DOB_MONTH.current.value;
        let year = DOB_YEAR.current.value;
    
        // let currentAge = calculateAge(day, month, year);
        // INPUT_AGE.current.value = currentAge;

        if(name === 'month')
        {
            let days = getDaysInMonth(Number(month));
            let daysList = getDaysList(days);
            console.log('Day List :', daysList);
            setDDdays(daysList);
        }
        console.log('Month: ', month);
    };

    const onSubmit = async(e) => {
        e.preventDefault();
        
        // Form Validation
        if(formValidation())
        {
            // be able to regis
            let regisInfo = await getFormData();
            nextPage(regisInfo);
            // openAlert('ทำรายการไม่สำเร็จ', 'เนื่องจากข้อมูลของท่านมีในระบบอยู่แล้ว ท่านสามารถติดต่อสอบถามได้ที่ +66 3825 9986 (ทั่วประเทศ)', 'ปิด');
        }
    };

    const regisMemberLab = (data) => {
        return new Promise(async resolve => {
            let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            let reqData = {
                Firstname: data.first_name_th,
                Lastname: data.last_name_th,
                Birthday: data.dob,
                Phoneno: data.phone_number,
                Email: data.email,
                line_display: lineProfile.display_name,
                line_profile: lineProfile.picture_url,
                line_user: lineProfile.user_id,
                line_token: lineProfile.id_token,
                isinvite: false,
                invite_line_user: "",
            }
            NhealthAction.RegisMember(reqData)
            .then(res => {
                console.log("register card member: ", res);
                if(res.isSuccess === true)
                {
                    resolve();
                }else
                {
                    // openAlert('ไม่สำเร็จ', res.errMessage, 'ตกลง');
                    //! bypass
                    // resolve(); // พี่นุ๊กเอา verify otp ในเส้น regis card member ออก ให้เอาตรงนี้ออกไป
                }
            })

            resolve();
        })
    }

    const checkUser = () => {
        return new Promise(((resolve, reject) => {
            let phone_number = String(INPUT_PHONE_NUMBER.current.value).replace(/\D/g, ''); 
            let enc_phone_number = EncryptedText(phone_number);
            let reqData = {data: enc_phone_number}

            // Check Phone
            APIS_ACTION.Signin_Phone(reqData)
            .then(res => {
                console.log(res);
                if(res.IsSuccess === false && res.ErrCode === 0)
                {
                    // Check Email
                    let email = String(INPUT_EMAIL.current.value);
                    if(!!email)
                    {
                        let reqDataEmail = {data: EncryptedText(email)}
    
                        APIS_ACTION.Signin_Email(reqDataEmail)
                        .then(res => {
                            if(res.IsSuccess === false && res.ErrCode === 0) 
                            {
                                resolve(); // ไม่มีในระบบ สามารถสมัครสมาชิกต่อได้
                            }else
                            {
                                reject();
                            }
                        })
                    }else
                    {
                        resolve();
                    }
                }else
                {
                    reject();
                }
            })
        }))
    }

    const getFormData = () => {
        return new Promise(async resolve => {
            let cardid = typeRegis ? String(INPUT_CARD_ID.current.value).replace(/\D/g, '') : String(INPUT_PASSPORT_ID.current.value).replace(/[^a-zA-Z0-9]/g, ''); // true = idcard | false = passport
            let back_idcard = typeRegis ? String(formData.back_idcard).replace(/[^a-zA-Z0-9]/g, ''): "";
            let first_name_th = String(INPUT_FIRSTNAME_TH.current.value);
            let last_name_th = String(INPUT_LASTNAME_TH.current.value);
            let first_name_en = String(INPUT_FIRSTNAME_EN.current.value);
            let last_name_en = String(INPUT_LASTNAME_EN.current.value);
            let dob = moment(String(`${DOB_DAY.current.value}-${DOB_MONTH.current.value}-${DOB_YEAR.current.value}`), 'DD-M-YYYY').format('DD-MM-YYYY');
            let gender = formData.gender;
            let phone_number = String(INPUT_PHONE_NUMBER.current.value).replace(/\D/g, '');
            let email = INPUT_EMAIL.current.value;

            console.log('Card ID: ', cardid);
            console.log('Back ID Card: ', back_idcard);
            console.log('first name TH: ', first_name_th);
            console.log('last name TH: ', last_name_th);
            console.log('first name EN: ', first_name_en);
            console.log('last name EN: ', last_name_en);
            console.log('DOB: ', dob);
            console.log('Gender: ', gender);
            console.log('Phone Number: ', phone_number);
            console.log('Email: ', email);

            let regis_info = {
                cardid,
                back_idcard,
                first_name_th,
                last_name_th,
                first_name_en,
                last_name_en,
                dob,
                gender,
                phone_number,
                email,
            }
            let enc_regis_info = EncryptedOBJ(regis_info);
            localStorage.setItem(process.env.REACT_APP_ENC_NAME_REGIS_PAYLOAD, enc_regis_info);
            // เซท type otp เพื่อให้หน้า otp รู้ว่า otp มาจาก register หรือ login
            let type_otp = EncryptedText('register');
            localStorage.setItem(process.env.REACT_APP_ENC_NAME_TYPE_OTP, type_otp);
            localStorage.setItem(process.env.REACT_APP_ENC_NAME_IS_CARD_MEMBER, EncryptedText(String(isCardMember))); // true or false

            resolve(regis_info);
        })
    }

    const formValidation = () => {
        let card_id = typeRegis ? String(INPUT_CARD_ID.current.value).replace(/-/g, '') : null;
        let passport = typeRegis ? null : String(INPUT_PASSPORT_ID.current.value);
        let backidcard = typeRegis ? String(formData.back_idcard).replace(/-/g, '') : null;

        let first_name_th = String(INPUT_FIRSTNAME_TH.current.value);
        let last_name_th = String(INPUT_LASTNAME_TH.current.value);
        let first_name_en = String(INPUT_FIRSTNAME_EN.current.value);
        let last_name_en = String(INPUT_LASTNAME_EN.current.value);

        let gender = formData.gender;
        // let age = Number(INPUT_AGE.current.value);
        let phone_number = String(INPUT_PHONE_NUMBER.current.value).replace(/\D/g, '');
        let email = INPUT_EMAIL.current.value;

        let errors = {};
        let formIsValid = true;

        if((!card_id || card_id.length < 13) && typeRegis === true) // typeRegis = true => สมัครด้วย idcard false = passport
        {
            // กรุณากรอกเลขประจำตัวประชาชนให้ครบถ้วน
            errors["idcard"] = "*กรุณากรอกเลขประจำตัวประชาชนให้ครบถ้วน";
            formIsValid = false;
        }
        if((!backidcard || backidcard.length < 12) && typeRegis === true) // typeRegis = true => สมัครด้วย idcard false = passport
        {
            // กรุณากรอกเลขประจำตัวประชาชนให้ครบถ้วน
            errors["back_idcard"] = "*กรุณากรอกเลขหลังบัตรประจำตัวประชาชนให้ครบถ้วน";
            formIsValid = false;
        }

        if((!passport || !isValidPassportFormat(passport)) && typeRegis === false)
        {
            // กรุณากรอกพาสปอร์ตให้ครบถ้วน
            errors["passport"] = "*กรุณากรอกพาสปอร์ตให้ครบถ้วน";
            formIsValid = false;
        }
        
        if(!first_name_th || first_name_th.length <= 0)
        {
            // กรุณากรอก ชื่อ นามสกุล ภาษาไทย ให้ครบถ้วน
            errors["first_name_th"] = "*กรุณากรอก ชื่อ ภาษาไทยให้ครบถ้วน";
            formIsValid = false;
        }else
        {
            if(!containsThaiCharacters(first_name_th))
            {
                // กรุณากรอกชื่อภาษาไทย
                errors["first_name_th"] = "*กรุณากรอกชื่อภาษาไทย";
                formIsValid = false; 
            }
        }
        if(!last_name_th || last_name_th.length <= 0)
        {
            // กรุณากรอก ชื่อ นามสกุล ภาษาไทย ให้ครบถ้วน
            errors["last_name_th"] = "*กรุณากรอก นามสกุล ภาษาไทยให้ครบถ้วน";
            formIsValid = false;
        }else
        {
            if(!containsThaiCharacters(last_name_th))
            {
                // กรุณากรอกชื่อภาษาไทย
                errors["last_name_th"] = "*กรุณากรอก นามสกุล ภาษาไทย";
                formIsValid = false; 
            }
        }
        
        if(!first_name_en || first_name_en.length <= 0)
        {
            // กรุณากรอก ชื่อ นามสกุล ภาษาอังกฤษ ให้ครบถ้วน
            errors["first_name_en"] = "*กรุณากรอก ชื่อ ภาษาอังกฤษให้ครบถ้วน";
            formIsValid = false;
        }else
        {
            if(!containsEnglishCharacters(first_name_en))
            {
                // กรุณากรอกชื่อภาษาไทย
                errors["first_name_en"] = "*กรุณากรอกชื่อภาษาอังกฤษ";
                formIsValid = false; 
            }
        }
        if(!last_name_en || last_name_en.length <= 0)
        {
            // กรุณากรอก ชื่อ นามสกุล ภาษาอังกฤษ ให้ครบถ้วน
            errors["last_name_en"] = "*กรุณากรอก นามสกุล ภาษาอังกฤษให้ครบถ้วน";
            formIsValid = false;
        }else
        {
            if(!containsEnglishCharacters(last_name_en))
            {
                // กรุณากรอกชื่อภาษาไทย
                errors["last_name_en"] = "*กรุณากรอกนามสกุลภาษาอังกฤษ";
                formIsValid = false; 
            }
        }
        
        if(!gender || gender === '')
        {
            // กรุณาระบุเพศ
            errors["gender"] = "*กรุณาระบุเพศ";    
            formIsValid = false;
        }
        
        if(!phone_number || phone_number.length < 10)  
        {
            // กรุณากรอกเบอร์โทรศัพท์ให้ครบถ้วน
            errors["tel"] = "*กรุณากรอกเบอร์โทรศัพท์ให้ครบถ้วน";    
            formIsValid = false;
        }

        if(!email || email.length === 0)  
        {
            // กรุณากรอกเบอร์โทรศัพท์ให้ครบถ้วน
            errors["email"] = "*กรุณากรอกอีเมลให้ครบถ้วน";    
            formIsValid = false;
        }
        
        if(!!email && email.length > 0)
        {
            // checking email
            if(!isValidEmail(email))
            {
               // กรุณากรอกอีเมลให้ถูกต้อง
               errors["email"] = "*กรุณากรอกอีเมลให้ถูกต้อง";    
               formIsValid = false; 
            }
        }

        setErrorMsg(errors);
        return formIsValid;
    }

    function isValidPassportFormat(passportNumber) {
        // Remove all non-alphanumeric characters from the passport number
        const cleanedPassportNumber = passportNumber.replace(/[^a-zA-Z0-9]/g, '');
      
        // Check if the cleaned passport number matches the format
        const validFormat = /^[A-Z]{1,2}\d{6,7}$/.test(cleanedPassportNumber);
      
        return validFormat;
    }

    const nextPage = async(regisInfo) => {
        if(!isLab)
        {
            await regisMemberLab(regisInfo)
            await checkSsoMemberStatus(regisInfo.phone_number)
            .then((status) => {
                if(status) // already had sso account
                {
                   let callbackURL =  DecryptedText(localStorage.getItem(process.env.REACT_APP_ENC_NAME_SIGNED_CALLBACK_URL));
                   ALERT.customAlert('ไม่สำเร็จ', 'เบอร์โทรศัพท์ของท่านเป็นสมาชิกอยู่แล้ว', 'ล็อกอิน', () => {
                       location.href = callbackURL;
                   });
                }else
                {
                    localStorage.removeItem(process.env.REACT_APP_ENC_NAME_OTP_START_TIME); 
                    localStorage.removeItem(process.env.REACT_APP_ENC_NAME_OTP_DATA); 
                    location.href = `${Base_API.pathWeb}/n-health/signup/otp`;
                }
            })
        }else
        {
            await checkSsoMemberStatus(regisInfo.phone_number)
            .then((status) => {
                if(status) // already had sso account
                {
                   let callbackURL =  DecryptedText(localStorage.getItem(process.env.REACT_APP_ENC_NAME_SIGNED_CALLBACK_URL));
                   ALERT.customAlert('ไม่สำเร็จ', 'เบอร์โทรศัพท์ของท่านเป็นสมาชิกอยู่แล้ว', 'ล็อกอิน', () => {
                    location.href = callbackURL;
                    });
                }else
                {
                    localStorage.removeItem(process.env.REACT_APP_ENC_NAME_OTP_START_TIME); 
                    localStorage.removeItem(process.env.REACT_APP_ENC_NAME_OTP_DATA); 
                    location.href = `${Base_API.pathWeb}/n-health/signup/otp`;
                }
            })
        }
    };

    const isValidEmail = (email) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    };

    const handleChangePassport = (e) => {
        let name = e.target.name;
        let value = String(e.target.value).replace(/[^a-zA-Z0-9]/g, '');
        let formatValue = formatPassportNumber(value);

        if(!!value && isValidPassportFormat(formatValue))
        {
            setErrorMsg({
                ...errorMsg, passport: ''
            }) 
        }else
        {
            setErrorMsg({
                ...errorMsg, passport: '*กรุณากรอกพาสปอร์ตให้ครบถ้วน'
            })
        }
        
        setFormData({ ...formData, passport: formatValue });
    }

    function formatPassportNumber(passportNumber) {
        // Remove all non-alphanumeric characters from the passport number
        const cleanedPassportNumber = passportNumber.replace(/[^a-zA-Z0-9]/g, '');
      
        // Convert letters to uppercase
        const uppercasePassportNumber = cleanedPassportNumber.toUpperCase();

        // Split the cleaned passport number into parts: letters and numbers
        const letters = uppercasePassportNumber.match(/[a-zA-Z]+/);
        const numbers = uppercasePassportNumber.match(/\d+/);
      
        // Check if both letters and numbers parts are present
        if (letters && numbers) {
          // Create the formatted passport number
          const formattedPassportNumber = `(${letters[0]}) ${numbers[0]}`;
          return formattedPassportNumber;
        } else {
          // Return the original cleaned passport number if formatting is not possible
          return uppercasePassportNumber;
        }
      }

    const onlyInputNumber = async(e) => {
        let name = e.target.name;
        let value = e.target.value;
        const numericValue = value.replace(/\D/g, '');
    
        if (name === "card_id") {
            const isNumber = /^[\d-]*$/.test(value);
            if (isNumber) {
                if (numericValue.length <= 13) {
                    let formatValue = formatNationalID(numericValue);
                    setFormData({ ...formData, card_id: formatValue });
                }
            }
            
            // Handle Error
            if(!numericValue || numericValue.length < 13)
            {
                // กรุณากรอกเลขประจำตัวประชาชนให้ครบถ้วน
                setErrorMsg({...errorMsg, idcard: "*กรุณากรอกเลขประจำตัวประชาชนให้ครบถ้วน"});
            }else
            {
                setErrorMsg({...errorMsg, idcard: ""});
            }
        }
        if (name === "tel") {
            const isPhoneNumberValid = /^[\d()\s-]*$/.test(value);
            const cleanedValue = value.replace(/\D/g, '');
            if (isPhoneNumberValid) {
                if (cleanedValue.length === 10) {
                    let formatValue = formatThaiPhoneNumber(cleanedValue);
                    setFormData({ ...formData, phone: formatValue });
                    await checkSsoMember(cleanedValue)
                } else {
                    setFormData({ ...formData, phone: cleanedValue });
                }
            }
            
            if(!cleanedValue || cleanedValue.length < 10)  
            {
                // กรุณากรอกเบอร์โทรศัพท์ให้ครบถ้วน
                setErrorMsg({...errorMsg, tel: "*กรุณากรอกเบอร์โทรศัพท์ให้ครบถ้วน"});
            }else
            {
                setErrorMsg({...errorMsg, tel: ""});
            }
        }
    }
    
    const checkSsoMember = (phoneNo) => {
        return new Promise(async resolve => {
            isContentLoading(true);
            let getHeader = await getHeadersAuthenLineId();
            let headers = {
                headers: {
                    Authorization: `Bearer ${getHeader.token}`,
                    userRef: getHeader.userRef,
                    authorizeRef: getHeader.authorizeRef,
                    channalRef: getHeader.channalRef
                }
            }
            let reqData = {
                data: EncryptedText(phoneNo)
            }

            NhealthAction.SignInPhone(reqData, headers)
            .then(res => {
                console.log(res);
                if(res.IsSuccess) 
                {
                    if(isCardMember)
                    {
                        localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE, EncryptedOBJ(res))
                        if(res.isType === 1) 
                        {
                            isContentLoading(false);
                            resolve();   
                        }else // have sso
                        {
                            if(!isLab)
                            {

                                openAlert('แจ้งเตือน', 'หมายเลขโทรศัพท์นี้มีสมาชิกอยู่แล้ว', 'ปิด');  
                                setFormData({ ...formData, phone: "" });
                                resolve();  
                            }
                        }
                    }else
                    {
                        console.log('is card member = false');
                        console.log('set new signin response: ', res);
                        localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE, EncryptedOBJ(res))
                        isContentLoading(false);
                        resolve();
                    }
                }else
                {
                    openAlert('เกิดข้อผิดพลาด', 'ระบบตรวจสอบสมาชิกด้วยหมายเลขโทรศัพท์ ไม่สามารถทำรายการได้ในขณะนี้', 'ปิด');
                    setFormData({ ...formData, phone: "" });
                    resolve();  
                }
            })
        }) 
    }
    const checkSsoMemberStatus = (phoneNo) => {
        return new Promise(async resolve => {
            isContentLoading(true);
            let getHeader = await getHeadersAuthenLineId();
            let headers = {
                headers: {
                    Authorization: `Bearer ${getHeader.token}`,
                    userRef: getHeader.userRef,
                    authorizeRef: getHeader.authorizeRef,
                    channalRef: getHeader.channalRef
                }
            }
            let reqData = {
                data: EncryptedText(phoneNo)
            }

            NhealthAction.SignInPhone(reqData, headers)
            .then(res => {
                console.log(res);
                if(res.IsSuccess) 
                {
                    localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE, EncryptedOBJ(res))
                    if(res.isType === 1) 
                    {
                        resolve(false);   
                    }else // have sso
                    {
                        resolve(true); 
                    }
                }else
                {
                    openAlert('เกิดข้อผิดพลาด', 'ระบบตรวจสอบสมาชิกด้วยหมายเลขโทรศัพท์ ไม่สามารถทำรายการได้ในขณะนี้', 'ปิด');
                    setFormData({ ...formData, phone: "" });
                    resolve();  
                }
            })
        }) 
    }


    const formatThaiPhoneNumber = (value) => {
        const numericValue = value.replace(/\D/g, '');
        let formattedValue = numericValue;
    
        if (numericValue.length > 3) {
            formattedValue = numericValue.replace(/^(\d{3,3})(\d{0,3})(\d{0,4})$/, '($1) $2-$3');
        }
    
        return formattedValue;
    };
    
    const formatNationalID = (value) => {
        const numericValue = value.replace(/\D/g, '');
        const formattedValue = numericValue.replace(/^(\d{1,1})(\d{4,4})(\d{5,5})(\d{2,2})(\d{1,1})$/, '$1-$2-$3-$4-$5');
        return formattedValue;
    };

    const formatBackCardID = (value) => {
        const alphanumericValue = value.replace(/[^a-zA-Z0-9]/g, '');
        const formattedValue = alphanumericValue.replace(/(.{3})(.{7})(.{2})/, '$1-$2-$3');
        return formattedValue;
    };

    const checkValidInput = (e) => {
        let name = e.target.name;
        let value = e.target.value

        if(name === "fname_th")
        {
            if(!value || value.length <= 0)
            {
                // กรุณากรอก ชื่อ ภาษาไทย ให้ครบถ้วน
                setErrorMsg({...errorMsg, first_name_th: "*กรุณากรอก ชื่อ ภาษาไทยให้ครบถ้วน"})
                setFormData({...formData, first_name_th: ""})
            }else
            {
                if(!containsThaiCharacters(value))
                {
                    // กรุณากรอกชื่อภาษาไทย
                    setErrorMsg({...errorMsg, first_name_th: "*กรุณากรอก ชื่อ ภาษาไทย"})
                }else
                {
                    let cleanValue = sanitizeInput(value); 
                    setErrorMsg({...errorMsg, first_name_th: ""})
                    setFormData({...formData, first_name_th: cleanValue})
                }
            }
        }
        if(name === "lname_th")
        {
            if(!value || value.length <= 0)
            {
                // กรุณากรอก นามสกุล ภาษาไทย ให้ครบถ้วน
                setErrorMsg({...errorMsg, last_name_th: "*กรุณากรอก นามสกุล ภาษาไทยให้ครบถ้วน"})
                setFormData({...formData, last_name_th: ""})
            }else
            {
                if(!containsThaiCharacters(value))
                {
                    // กรุณากรอก นามสกุล ภาษาไทย
                    setErrorMsg({...errorMsg, last_name_th: "*กรุณากรอก นามสกุล ภาษาไทย"})
                }else
                {
                    let cleanValue = sanitizeInput(value);
                    setErrorMsg({...errorMsg, last_name_th: ""})
                    setFormData({...formData, last_name_th: cleanValue})
                }
            }
        }
        if(name === "fname_en")
        {
            if(!value || value.length <= 0)
            {
                // กรุณากรอก ชื่อ ภาษาไทย ให้ครบถ้วน
                setErrorMsg({...errorMsg, first_name_en: "*กรุณากรอก ชื่อ ภาษาอังกฤษให้ครบถ้วน"})
                setFormData({...formData, first_name_en: ""})
            }else
            {
                if(!containsEnglishCharacters(value))
                {
                    // กรุณากรอก ชื่อ ภาษาไทย
                    setErrorMsg({...errorMsg, first_name_en: "*กรุณากรอก ชื่อ ภาษาอังกฤษ"})
                }else
                {
                    let cleanValue = sanitizeInput(value);
                    setErrorMsg({...errorMsg, first_name_en: ""})
                    setFormData({...formData, first_name_en: cleanValue})
                }
            }
        }
        if(name === "lname_en")
        {
            if(!value || value.length <= 0)
            {
                // กรุณากรอก นามสกุล ภาษาไทย ให้ครบถ้วน
                setErrorMsg({...errorMsg, last_name_en: "*กรุณากรอก นามสกุล ภาษาอังกฤษให้ครบถ้วน"})
                setFormData({...formData, last_name_en: ""})
            }else
            {
                if(!containsEnglishCharacters(value))
                {
                    // กรุณากรอก นามสกุล ภาษาไทย
                    setErrorMsg({...errorMsg, last_name_en: "*กรุณากรอก นามสกุล ภาษาอังกฤษ"})
                }else
                {
                    let cleanValue = sanitizeInput(value);
                    setErrorMsg({...errorMsg, last_name_en: ""})
                    setFormData({...formData, last_name_en: cleanValue})
                }
            }
        }
        if(name === "gender")
        {
            setFormData({...formData, gender: value})
            if(!!value)
            {
                setErrorMsg({...errorMsg, gender: ""})
            }
        }
        if(name === "email")
        {
            if(!!value && value.length <= 0)
            {
                setErrorMsg({...errorMsg, email: "*กรุณากรอกอีเมลให้ครบถ้วน"})
                setFormData({...formData, email: ""})
            }else
            {
                // checking email
                if(!isValidEmail(value))
                {
                    let cleanValue = sanitizeInput(value);
                    setFormData({...formData, email: cleanValue})
                   // กรุณากรอกอีเมลให้ถูกต้อง
                   setErrorMsg({...errorMsg, email: "*กรุณากรอกอีเมลให้ถูกต้อง"})
                }else
                {
                    let cleanValue = sanitizeInput(value);
                    setFormData({...formData, email: cleanValue})
                    setErrorMsg({...errorMsg, email: ""})
                }
            }
        }
    }

    const backCardIDChange = (e) => {
        let value = e.target.value;
        const alphanumericValue = String(value.replace(/[^a-zA-Z0-9]/g, '')).toUpperCase();
        if(alphanumericValue.length === 12)
        {
            let formatValue = formatBackCardID(alphanumericValue)
            setFormData({...formData, back_idcard: formatValue})
            setErrorMsg({...errorMsg, back_idcard: ""})
        }else
        {
            setFormData({...formData, back_idcard: alphanumericValue})
            setErrorMsg({...errorMsg, back_idcard: "*กรุณากรอกเลขหลังบัตรประจำตัวประชาชนให้ครบถ้วน"})
        }
    }

    function containsEnglishCharacters(input) {
        const englishPattern = /[A-Za-z]/; // English letters
        return englishPattern.test(input);
    }
    function containsThaiCharacters(input) {
        const thaiPattern = /[\u0E00-\u0E7F]/; // Thai Unicode range
        return thaiPattern.test(input);
    }

    const openAlert = (title, body, button) => {
        let alertConfirmElem = (
          <div className="swal-cfpm">
            <div className="top">
              <img onClick={handleCloseAlert} src={CLOSE_ICON} />
            </div>
      
            <div className="mid">
              <h2 className="title">{title}</h2>
              <p className="desc">
                {body}
              </p>
            </div>
      
            <div className={`bottom`}>
              <button type="button" onClick={handleCloseAlert}>
                {button}
              </button>
            </div>
          </div>
        );
    
        MySwal.fire({
          html: alertConfirmElem,
          showCancelButton: false,
          showConfirmButton: false,
          allowOutsideClick: false,
        });
    
      };
    
    const handleCloseAlert = () => {
        isContentLoading(false);
        MySwal.close();
    };

    const onSkip = () => {
        localStorage.removeItem(process.env.REACT_APP_ENC_NAME_OTP_START_TIME); 
        localStorage.removeItem(process.env.REACT_APP_ENC_NAME_OTP_DATA); 
        location.href = `${Base_API.pathWeb}/n-health/signup/otp`;
    }

    function sanitizeInput(input) {
        // Replace '<' and '>' characters with their HTML entities
        const sanitized = input.replace(/</g, "").replace(/>/g, "");
        return sanitized;
    }

    return (
        <>
            <div className="signup-forminfo-con container-profile">
                <ContentLoader/>
                <PageLoader /> 
                <SignIn_Navbar canClose={false} />

                <h3 className="header-text">
                    กรุณาตรวจสอบข้อมูล และกรอกข้อมูลให้ครบถ้วน
                </h3>

                <form action="#" onSubmit={onSubmit} className="form-wrap">
                    {typeRegis
                        ? 
                            <div className="form-group"  name="id-card">
                                <label htmlFor="id-card">บัตรประชาชน</label>
                                <input
                                    ref={INPUT_CARD_ID} 
                                    type="text" id="id-card" 
                                    readOnly={lockInputCardID} 
                                    placeholder="กรอกเลขบัตรประชาชน" 
                                    value={formData.card_id}
                                    maxLength={17}
                                    name="card_id"
                                    onChange={onlyInputNumber}
                                />
                                <p className="input-error">
                                    {errorMsg["idcard"]}
                                </p>
                            </div>
                        :
                            <div className="form-group"  name="id-card">
                                <label htmlFor="id-card">พาสปอร์ต</label>
                                <input
                                    ref={INPUT_PASSPORT_ID} 
                                    type="text" id="passport-id" 
                                    placeholder="กรอกพาสปอร์ต" 
                                    value={formData.passport}
                                    maxLength={15}
                                    name="passport_id"
                                    onChange={handleChangePassport}
                                />
                                <p className="input-error">
                                    {errorMsg["passport"]}
                                </p>
                            </div>
                    }

                    <div className="form-group" name="fname">
                        <label htmlFor="backcard_id">เลขหลังบัตรประชาชน<br/><span className="text-blue">ขึ้นต้นด้วยตัวอักษร 2 ตัว ตามด้วยเลข 10 หลัก</span></label>
                        <input
                            type="text"
                            id="backcard_id"
                            name="backcard_id"
                            placeholder="กรอกเลขหลังบัตรประชาชน"
                            onChange={backCardIDChange}
                            value={formData.back_idcard}
                            maxLength={12}
                        />
                        <p className="input-error">
                            {errorMsg["back_idcard"]}
                        </p>
                    </div>

                    <div className="form-group" name="fname">
                        <label htmlFor="fname">ชื่อ (ภาษาไทย)</label>
                        <input
                            type="text"
                            id="fname"
                            name="fname_th"
                            ref={INPUT_FIRSTNAME_TH}
                            value={formData.first_name_th}
                            placeholder="กรอกชื่อ (ภาษาไทย)"
                            onChange={checkValidInput}
                        />
                        <p className="input-error">
                            {errorMsg["first_name_th"]}
                        </p>
                    </div>
                    <div className="form-group" name="fname">
                        <label htmlFor="fname">นามสกุล (ภาษาไทย)</label>
                        <input
                            type="text"
                            id="fname"
                            name="lname_th"
                            ref={INPUT_LASTNAME_TH}
                            value={formData.last_name_th}
                            placeholder="กรอกนามสกุล (ภาษาไทย)"
                            onChange={checkValidInput}
                        />
                        <p className="input-error">
                            {errorMsg["last_name_th"]}
                        </p>
                    </div>
                    <div className="form-group" name="fname">
                        <label htmlFor="fname">ชื่อ (ภาษาอังกฤษ)</label>
                        <input
                            type="text"
                            id="fname"
                            name="fname_en"
                            ref={INPUT_FIRSTNAME_EN}
                            value={formData.first_name_en}
                            placeholder="กรอกชื่อ (ภาษาอังกฤษ)"
                            onChange={checkValidInput}
                        />
                        <p className="input-error">
                            {errorMsg["first_name_en"]}
                        </p>
                    </div>
                    <div className="form-group" name="fname">
                        <label htmlFor="fname">นามสกุล (ภาษาอังกฤษ)</label>
                        <input
                            type="text"
                            id="fname"
                            name="lname_en"
                            ref={INPUT_LASTNAME_EN}
                            value={formData.last_name_en}
                            placeholder="กรอกนามสกุล (ภาษาอังกฤษ)"
                            onChange={checkValidInput}
                        />
                        <p className="input-error">
                            {errorMsg["last_name_en"]}
                        </p>
                    </div>

                    {/* <div className="form-group" name="fname">
                        <label htmlFor="fname">ชื่อ-นามสกุล (ภาษาไทย)</label>
                        <input
                            type="text"
                            id="fname"
                            name="fname_th"
                            ref={INPUT_FULLNAME_TH}
                            placeholder="กรอกชื่อ-นามสกุล (ภาษาไทย)"
                            onChange={checkValidInput}
                        />
                        <p className="input-error">
                            {errorMsg["fullname_th"]}
                        </p>
                    </div>
                    <div className="form-group" name="lname">
                        <label htmlFor="lname">ชื่อ-นามสกุล (ภาษาอังกฤษ)</label>
                        <input
                            type="text"
                            id="lname"
                            name="fname_en"
                            placeholder="กรอกชื่อ-นามสกุล (ภาษาอังกฤษ)"
                            ref={INPUT_FULLNAME_EN}
                            onChange={checkValidInput}
                        />
                        <p className="input-error">
                            {errorMsg["fullname_en"]}
                        </p>
                    </div> */}
                    <div className="form-group" name="dob">
                        <label htmlFor="#">วันเดือนปีเกิด (ค.ศ.)</label>
                        <div className="sub-form-group">
                            <div className="left">
                                <select defaultValue={1} name="dob" onChange={handleChange} ref={DOB_DAY}>
                                    {ddDays.map((item) => (
                                        <option value={item} key={item}>
                                            {item}
                                        </option>
                                    ))}
                                </select>
                                <img
                                    src={ARROW_DOWN_ICON}
                                    className="arrow"
                                />
                            </div>
                            <div className="mid">
                                <select
                                    defaultValue={1}
                                    name="month"
                                    onChange={handleChange}
                                    ref={DOB_MONTH}
                                >
                                    {ddMonth.map((item) => (
                                        <option value={item.id} key={item.id}>
                                            {item.nameTH}
                                        </option>
                                    ))}
                                </select>
                                <img
                                    src={ARROW_DOWN_ICON}
                                    className="arrow"
                                />
                            </div>
                            <div className="right">
                                <select defaultValue={1} ref={DOB_YEAR} name="dob" onChange={handleChange}>
                                    {ddYears.map((item) => (
                                        <option value={item} key={item}>
                                            {item}
                                        </option>
                                    ))}
                                </select>
                                <img
                                    src={ARROW_DOWN_ICON}
                                    className="arrow"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="form-group" name="gender2">
                        <label>เพศ</label> 
                        <div className="group-gdbtn">
                            <input onChange={checkValidInput} type="radio" name="gender" value="female" id="female" />
                            <label htmlFor="female">หญิง</label>
                            <input onChange={checkValidInput} type="radio" name="gender" value="male" id="male" />
                            <label htmlFor="male">ชาย</label>
                        </div>
                        <p className="input-error">
                           {errorMsg["gender"]}
                        </p>
                    </div>


                    {/* <div className="form-group" name="gender-age">
                        <div className="left">
                            <label htmlFor="gender">เพศ</label>
                            <span>
                                <select 
                                    defaultValue={"default"}
                                    ref={DD_GENDER}
                                    // onFocus={() => $('#slgender-default').remove()}
                                    name="gender"
                                    onChange={checkValidInput}
                                >
                                    <optgroup label="ระบุเพศ">
                                        <option id="slgender-default" disabled selected value="default">-</option>
                                        {ddGender.map((item) => (
                                            <option value={item.id} key={item.id}>
                                                {item.nameTH}
                                            </option>
                                        ))}
                                    </optgroup>
                                </select>
                                <img
                                    src={ARROW_DOWN_ICON}
                                    className="arrow"
                                />
                            </span>
                        </div>
                        <div className="right">
                            <label htmlFor="age">อายุ</label>
                            <input type="number" ref={INPUT_AGE} defaultValue={0} disabled />
                        </div>
                        <p className="input-error">
                            {errorMsg["gender"]}
                        </p>
                        <p className="input-error">
                            {errorMsg["age"]}
                        </p>
                    </div> */}

                    <div className="form-group" name="phone">
                        <label>เบอร์โทรศัพท์<span className="text-danger">*</span></label>
                        <span>
                            <input
                                disabled={isCardMember}
                                type="tel"
                                ref={INPUT_PHONE_NUMBER}
                                maxLength={10}
                                placeholder="กรอกเบอร์โทรศัพท์"
                                value={formData.phone}
                                name="tel"
                                onChange={onlyInputNumber}
                            />
                            {isMembership === false &&
                                <p className="sso-phonnumber-checker">{ssoPhoneMsg}</p>
                            }
                        </span>
                        <p className="input-error">
                            {errorMsg["tel"]}
                        </p>
                    </div>
                    <div className="form-group" name="phone">
                        <label>อีเมล<span className="text-danger">*</span></label>
                        <input 
                            ref={INPUT_EMAIL} 
                            type="email" 
                            placeholder="กรอกอีเมล" 
                            name="email"
                            value={formData.email}
                            onChange={checkValidInput}
                        />
                        <p className="input-error">
                            {errorMsg["email"]}
                        </p>
                    </div>

                    <button 
                        className={`btn-submit`} type="submit" 
                    >
                        ถัดไป
                    </button>
                </form>
                {/* <PrivacyPolicy /> */}
            </div>
        </>
    );
}
